__turbopack_context__.v({
  "hint": "PanelOptionList-module-scss-module__hHmz4a__hint",
  "list": "PanelOptionList-module-scss-module__hHmz4a__list",
  "option": "PanelOptionList-module-scss-module__hHmz4a__option",
  "radio": "PanelOptionList-module-scss-module__hHmz4a__radio",
  "selected": "PanelOptionList-module-scss-module__hHmz4a__selected",
  "text": "PanelOptionList-module-scss-module__hHmz4a__text",
});
